import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { getCurrentHostnameEndpoint, getFlow, setFlow, getLanguage, setLanguage, parseCategoryPlaceholders, parseArticlePlaceholders, arrayMove } from '@/utils/common'

var storeObject = {
  state: {
    i18n: {},
    locales: {},
    defaultLocale: '',
    siteDetails: {},
    flowObject: {},
    categories: {},
    articles: {},
    funnelHashes: {
      type: null,
      hashes: {}
    }
  },
  getters: {
    flowObject: state => state.flowObject,
    siteDetails: state => state.siteDetails,
    categories: state => state.categories,
    articles: state => state.articles,
    i18n: state => state.i18n
  },
  mutations: {
    updateFlowObject: (state, payload) => {
      state.flowObject = payload
    },
    updateSiteDetailsObject: (state, payload) => {
      state.siteDetails = payload
    },
    updateCategoriesObject: (state, payload) => {
      state.categories = payload
    },
    updateArticlesObject: (state, payload) => {
      state.articles = payload
    },
    updateI18n: (state, payload) => {
      state.i18n = payload
    },
    updateLocales: (state, payload) => {
      state.locales = payload
    },
    updateDefaultLocale: (state, payload) => {
      state.defaultLocale = payload
    },
    changeI18nLocal: (state, payload) => {
      state.i18n.locale = payload
    },
    updateFunnelHashes: (state, payload) => {
      state.funnelHashes.type = payload.competitorFunnelType;
      state.funnelHashes.hashes = payload.funnelHashes;
    }
  },
  actions: {
    fetchFlowObject: ({ commit, state }, payload) => {
      let endpoint = getCurrentHostnameEndpoint()
      let flow = getFlow()
      return axios
        .get(`${endpoint}/static/flows/${state.siteDetails.helpcenter_type}/${flow}.json`)
        .then(response => {
          return commit(`updateFlowObject`, response.data)
        })
        // If the user asks for a flow that doesn't exist, we default to zen
        .catch(() => {
          return axios.get(`${endpoint}/static/flows/${state.siteDetails.helpcenter_type}/zen.json`)
            .then(response => {
              setFlow('zen')
              return commit(`updateFlowObject`, response.data)
            })
        })
    },
    fetchSiteDetails: ({ commit }, payload) => {
      let endpoint = getCurrentHostnameEndpoint()
      let supportHostnameSplit = window.location.hostname.split('.');
      let supportHostname = supportHostnameSplit.length > 2 ? `${window.location.hostname.split('.')[1]}.${window.location.hostname.split('.')[2]}/` : '';
      return axios
        .get(`${endpoint}/static/siteDetails/${supportHostname}main.json`)
        .then(response => {
          return commit(`updateSiteDetailsObject`, response.data)
        })
    },
    fetchLocales: ({ commit, state }, payload) => {
      let endpoint = getCurrentHostnameEndpoint()
      return axios
        .get(`${endpoint}/static/zendesk/${state.siteDetails.helpcenter_type}/locales.json`)
        .then(response => {
          commit(`updateLocales`, response.data.locales);
          commit(`updateDefaultLocale`, response.data.default_locale);
        });
    },
    attachI18n: ({ commit }, payload) => {
      return commit(`updateI18n`, payload)
    },
    changeLanguage: ({ commit, dispatch }, payload) => {
      setLanguage(payload)
      return Promise.all([dispatch('fetchCategories', payload)])
        .then(() => {
          return commit(`changeI18nLocal`, payload)
        })
    },
    fetchCategories: ({ commit, state }, payload) => {
      let endpoint = getCurrentHostnameEndpoint()
      let language = payload || getLanguage()

      return axios
        .get(`${endpoint}/static/zendesk/${state.siteDetails.helpcenter_type}/${language}/categories.json`)
        .then(response => {
          var categories = parseCategoryPlaceholders(response.data);
          return commit(`updateCategoriesObject`, categories);
        });
    },
    fetchArticles: ({ commit, state }, payload) => {
      let endpoint = getCurrentHostnameEndpoint()
      let language = payload || getLanguage()

      return axios
        .get(`${endpoint}/static/zendesk/${state.siteDetails.helpcenter_type}/${language}/articles.json`)
        .then((response) => {
          parseArticlePlaceholders(response.data)
          return commit(`updateArticlesObject`, response.data)
        })
        .then(async () => {
          if (state.flowObject['zendesk']) {
            // Excludes
            if (state.flowObject['zendesk']['exclude']) {
              for (let categoryId of Object.keys(state.flowObject['zendesk']['exclude'])) {
                for (let articleId of state.flowObject['zendesk']['exclude'][categoryId]) {
                  for (let articleIndex in state.articles[categoryId]) {
                    if (state.articles[categoryId][articleIndex].source_id === Number(articleId)) {
                      state.articles[categoryId].splice(articleIndex, 1)
                    }
                  }
                }
              }
            }
            // Includes
            if (state.flowObject['zendesk']['include']) {
              for (let categoryId of Object.keys(state.flowObject['zendesk']['include'])) {
                for (let articleId of state.flowObject['zendesk']['include'][categoryId]) {
                  let article = await axios.get(`${endpoint}/static/zendesk/${state.siteDetails.helpcenter_type}/${language}/${articleId}.json`).then((response) => response.data)
                  state.articles[categoryId].push(article)

                  // Check if this article needs to be injected
                  if (state.flowObject['zendesk']['inject']) {
                    for (let categoryId of Object.keys(state.flowObject['zendesk']['inject'])) {
                      for (let articleToInject of state.flowObject['zendesk']['inject'][categoryId]) {
                        if (article.source_id === Number(articleToInject.articleId)) {
                          state.articles[categoryId].push(article);
                          arrayMove(state.articles[categoryId], state.articles[categoryId].length - 1, (articleToInject.position - 1));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        })
    }
  }
}

Vue.use(Vuex)

export default new Vuex.Store(storeObject)
